import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography} from 'views/components';

const ContactBox = (props) => {
  const {data} = props;

  return (
    <Box
      style={{
        background: 'white',
        borderRadius: '1rem',
        boxShadow: '0 1px 6px rgba(0,0,0,0.1)',
        padding: '1rem',
        position: 'relative',
        minHeight: 120,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{display: 'flex', flexDirection: 'column'}}>
        {
          data.name &&
          <Typography variant="h6" style={{fontSize: 15, marginBottom: 0}}>{data.name}</Typography>
        }
        {
          data.relationship &&
          <Typography variant="body2" style={{color: '#6b7280', fontSize: 13, marginTop: 0}}>
            {data.relationship}
          </Typography>
        }
      </Box>

      <Box sx={{display: 'flex', alignItems: 'center', gap: 1, mt: 1}}>
        {
          data.phoneNumber &&
          <Typography style={{color: '#374151', fontSize: 13}}>
            {data.phoneNumber}
          </Typography>
        }
      </Box>

      <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
        {
          data.email &&
          <Typography style={{color: '#374151', fontSize: 13}}>
            {data.email}
          </Typography>
        }
      </Box>
    </Box>
  );
};

ContactBox.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    relationship: PropTypes.string,
    phoneNumber: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
};

export default ContactBox;
